<template>
  <div>
    <table id="table-preco-mercado-close-up">
      <tr class="text-left">
        <td
          v-for="(g, idx) in dados.geral"
          :key="idx"
          :colspan="g.colspan"
          class="pb-5"
        >
          <p class="subtitle-2">{{ g.text }}</p>
          <p>{{ g.value }}</p>
        </td>
      </tr>

      <tr style="border-bottom: 1px solid rgba(0,0,0,.08); font-weight: bolder;">
        <td></td>
        <td colspan="12" class="text-center font-14 py-1 bordar-esquerda-personalizada bordar-cima-personalizada">
          Quantidade de Venda
        </td>
      </tr>

      <tr>
        <th class="text-left pl-2 bordar-baixo-personalizada" style="min-width: 16%">
          Tipo
        </th>
        <th
          v-for="(periodo, idx) in dados.periodo"
          :key="idx"
          class="text-left pt-3 pb-2 bordar-baixo-personalizada"
          :class="{ 'bordar-esquerda-personalizada pl-2' : idx == 0 }"
        >
          {{ periodo.value }}
        </th>
      </tr>

      <tr class="text-left bordar-baixo-personalizada">
        <td>Análise Mercado</td>
        <td
          v-for="(planilha, idx) in dados.planilha"
          :key="idx"
          :class="{ 'bordar-esquerda-personalizada pl-2' : idx == 0 }"
        >
          {{ planilha.value ? planilha.value : 0 }}
        </td>
      </tr>

      <tr class="text-left bordar-baixo-personalizada">
        <td>{{ `Análise ${dados.grupo_atual}` }}</td>
        <td
          v-for="(consumo, idx) in dados.consumo"
          :key="idx"
          :class="{ 'bordar-esquerda-personalizada pl-2' : idx == 0 }"
        >
          {{ consumo.value ? consumo.value : 0 }}
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import Responsividade from "@/helpers/ResponsiveHeight";

export default {
  mixins: [ Responsividade ],
  props: {
    dados: {
      type: [Array, Object]
    }
  }
}
</script>

<style scoped>
.bordar-esquerda-personalizada {
  border-left: 1px solid rgba(0,0,0,.08);
}
.bordar-cima-personalizada {
  border-top: 1px solid rgba(0,0,0,.08);
}
.bordar-baixo-personalizada {
  border-bottom: 1px solid rgba(0,0,0,.08);
}
#table-preco-mercado-close-up {
  width: 100%;
  border-collapse: collapse;
}
#table-preco-mercado-close-up tr td {
  /* border-top: 1px solid rgba(0,0,0,.08);
  border-bottom: 1px solid rgba(0,0,0,.08); */
  width: 7%;
}
#table-preco-mercado-close-up tr td:first-child {
  padding-left: 8px;
}
#table-preco-mercado-close-up tr:first-child td:last-child {
  border-right: 0;
}
#table-preco-mercado-close-up tr th:last-child {
  border-right: 1px solid #d0cdcd;
}
#table-preco-mercado-close-up tr td:last-child {
  border-right: 1px solid #d0cdcd;
}
#table-preco-mercado-close-up tr td {
  padding-top: 7px;
  padding-bottom: 7px;
}
#table-preco-mercado-close-up tr td p {
  margin: 0;
}
</style>
